import React, { FC } from 'react';
import { Button, Empty, Skeleton, Tag } from 'antd';
import { useTranslate } from '@/translations';
import { BlockSkeleton } from '@/ui/components';

export const WidgetSkeleton = BlockSkeleton;

export const CardSkeleton: FC = () => (
  <Skeleton
    active
    title={{ width: '60%' }}
    paragraph={{ rows: 1, width: '40%' }}
  />
);

export const WidgetEmpty: FC<{ height?: number }> = ({ height = 240 }) => {
  const { t } = useTranslate();
  return (
    <div
      style={{
        height,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={t('dashboard.state.empty')}
      />
    </div>
  );
};

export const WidgetError: FC<{ onRetry?: () => void; height?: number }> = ({
  onRetry,
  height = 240,
}) => {
  const { t } = useTranslate();
  return (
    <div
      style={{
        height,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
      }}
    >
      <span>{t('dashboard.state.error')}</span>
      {onRetry ? (
        <Button size="small" onClick={onRetry}>
          {t('dashboard.state.retry')}
        </Button>
      ) : null}
    </div>
  );
};

export const SampleDataBadge: FC = () => {
  const { t } = useTranslate();
  return <Tag color="orange">{t('dashboard.sampleData')}</Tag>;
};
